import {
  filter as _filter,
  get as _get,
  orderBy as _orderBy,
  pick as _pick,
  some as _some,
  toLower as _toLower,
} from 'lodash-es';

type Many<T> = T | ReadonlyArray<T>;

type OrderBy = <T>(
  collection: ArrayLike<T> | null | undefined,
  iteratees: string,
  orders?: Many<boolean | 'asc' | 'desc'>,
) => T[];

export const orderBy: OrderBy = (data, sort, order) =>
  _orderBy(
    data,
    [
      (item) => {
        const field = _get(item, sort);
        return typeof field === 'string' ? _toLower(field) : field;
      },
    ],
    order,
  );

export const filter = <T extends Record<string, any>>(
  collection: ArrayLike<T>,
  text: string | undefined,
  include: string[],
  ignoreSpaces = false,
) => {
  const search = _toLower(text);
  return _filter(collection, (object) =>
    _some(
      _pick(object, include),
      (string) =>
        /*
           need to write a type guard ensuring that tje attrs
           included in include only grab string type values.
        */
        // @ts-ignore - TODO
        _toLower(ignoreSpaces ? string.replace(/\s/g, '') : string).includes(
          search,
        ) && !object.isArchived,
    ),
  );
};
